import { NgModule } from "@angular/core";
import { RouterModule, Route } from "@angular/router";
import { ValidatingEnrolleeComponent } from "./component/validating-enrollee/validating-enrollee.component";
import { DocViewerComponent } from "src/app/shared-module/doc-viewer/doc-viewer/doc-viewer.component";
import { GroupHRListComponent } from './component/group-hr-list/group-hr-list.component';
import { ClaimSubmissionComponent } from './component/claim-submission/claim-submission.component';
import { NewCaseApprovalComponent } from './component/new-case-approval/new-case-approval.component';
import { PpoListComponent } from './component/ppo-list/ppo-list.component';
import { HrDashboardComponent } from './component/hr-dashboard/hr-dashboard.component';
import { ClaimSubmissionIndComponent } from "./component/claim-submission-ind/claim-submission-ind.component";
import { ClaimSubmissionGlComponent } from "./component/claim-submission-gl/claim-submission-gl.component";
import { ClaimSubmissionBancaComponent } from "./component/claim-submission-banca/claim-submission-banca/claim-submission-banca.component";
import { NigoDocumentUploadPPOComponent } from "./component/nigo-document-upload-ppo/nigo-document-upload-ppo.component";
import { HrRouteGuard } from "src/app/utility/configuration/route-gurads/hr-route-guard";
import { HrDashboardClaimsReportComponent } from "./component/hr-dashboard-claims-report/hr-dashboard-claims-report.component";
import { HrClaimStatusComponent } from "./component/hr-claim-status/hr-claim-status.component";
const routes: Route[] = [
  {
    path: "validating-enrollee",
    component: ValidatingEnrolleeComponent,
    canActivate: [HrRouteGuard]
  },
  {
    path: "doc-view",
    component: DocViewerComponent,
    canActivate: [HrRouteGuard]
  },
  {
    path: "group-hr-list",
    component: GroupHRListComponent,
    canActivate: [HrRouteGuard]
  },
  {
    path: "claim-submission",
    component: ClaimSubmissionComponent
  },
  {
    path: "newCasePreApproval",
    component: NewCaseApprovalComponent,
    canActivate: [HrRouteGuard]
  },
  {
    path: "ppo-list",
    component: PpoListComponent,
    canActivate: [HrRouteGuard]
  },
  {
    path: "pre-approved-bill-entry/:id",
    component: NewCaseApprovalComponent,
    canActivate: [HrRouteGuard]
  },
  {
    path: "hr-dashboard",
    component: HrDashboardComponent,
    canActivate: [HrRouteGuard]
  },
  {
    path: "hr-claim-status",
    component: HrClaimStatusComponent,
    canActivate: [HrRouteGuard]
  },
  {
    path: "individual-claim-submission",
    component: ClaimSubmissionIndComponent
  },
  {
    path: "claim-submission-gl",
    component: ClaimSubmissionGlComponent,
    canActivate: [HrRouteGuard]
  },
  {
    path: "claim-submission-banca",
    component: ClaimSubmissionBancaComponent,
    canActivate: [HrRouteGuard]
  },
  {
    path: "hr-dashboard-claims-report",
    component: HrDashboardClaimsReportComponent,
    canActivate: [HrRouteGuard]
  },
  {
    path: "nigo-document-upload/:ppoRequestId/:claimEntryId",
    component: NigoDocumentUploadPPOComponent
  },
  // {
  //   path: "eb-dashboard-login",
  //   component: EbDashboardLoginComponent
  // },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RoutingModule { }
